import type { PaymentTagDef } from '@chewy/chat-library-common';
import '@chewy/kib-product-styles/dist/styles/kib-product-badges.css';
import styles from './Payments.module.scss';
import { getPaymentIcon } from './getPaymentIcon';
import { capitalize } from 'lodash';

export interface PaymentsProps {
  payments: PaymentTagDef[];
}

export default function Payments({ payments }: PaymentsProps) {
  if (!payments || payments.length === 0) {
    return null;
  }

  return (
    <div className={styles.payments}>
      {payments.map((payment, index) => (
        <div key={index} className={styles.payment}>
          <span className={styles.paymentMethod}>{getPaymentIcon(payment.paymentMethod)}</span>
          <span className={styles.label}>{capitalize(payment.label)}</span>
        </div>
      ))}
    </div>
  );
}
